import { render, staticRenderFns } from "./proreporthistory.vue?vue&type=template&id=03a10f2f&scoped=true&"
import script from "./proreporthistory.vue?vue&type=script&lang=js&"
export * from "./proreporthistory.vue?vue&type=script&lang=js&"
import style0 from "./proreporthistory.vue?vue&type=style&index=0&id=03a10f2f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a10f2f",
  null
  
)

export default component.exports